import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import DOMPurify from "dompurify";
import { getGuardianStudentLatestVerdicts, getGuardianStudentVerdicts, getPlanAssessments, getAssignmentAssessments, getVerdictScales } from 'actions/studyplans';
import Modal from 'containers/Modals/Modal';
import RowItem, { RowCell } from 'UI/Elements/List/RowItem';
import VerdictWidget from 'containers/Verdict/Display/Widget';
import VerdictDisplay from 'containers/Verdict/Display/Verdict';
import VerdictAssessmentsDisplay from 'containers/Verdict/Display/Assessments';
import Moment from 'moment';
import SectionTitle from 'components/Presentation/SectionTitle';
import DateTime from '_class/DateTime';
import { Spinner, DataList, Collapsible, ColorLabelContainer, ColorLabel, Person } from 'UI';
import { Button, Icon, translate, getActiveLanguage } from '@haldor/ui';
import './_studyPlan.scss';
import moment from 'moment';
var StudyPlans = /*#__PURE__*/function (_Component) {
  function StudyPlans(props) {
    var _this;
    _classCallCheck(this, StudyPlans);
    _this = _callSuper(this, StudyPlans, [props]);
    _defineProperty(_this, "loadData", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(studentId) {
        var promises;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.setState({
                loadingStudyPlan: true
              });
              promises = [];
              promises.push(_this.props.getVerdictScales(studentId, getActiveLanguage()));
              promises.push(_this.props.getGuardianStudentLatestVerdicts(studentId));
              _context.next = 1;
              return Promise.all(promises);
            case 1:
              _this.setState({
                loadingStudyPlan: false
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "onCourseClick", function (course) {
      var activeStudent = _this.props.activeStudent;
      _this.setState({
        verdictLoading: true,
        course: course
      });
      var promises = [];
      promises.push(_this.props.getPlanAssessments(activeStudent.id, course.id));
      promises.push(_this.props.getGuardianStudentVerdicts(activeStudent.id, course.id));
      promises.push(_this.props.getAssignmentAssessments(activeStudent.id, course.id));
      Promise.all(promises).then(function () {
        _this.setState({
          verdictLoading: false
        });
      });
      _this.toggleVerdictModal();
    });
    _defineProperty(_this, "toggleVerdictModal", function () {
      _this.setState({
        verdictModal: !_this.state.verdictModal
      });
    });
    _defineProperty(_this, "toggleOpen", function (course, active) {
      var open = _this.state.open;
      var found = _this.state.open.indexOf(course.id);
      if (active && found == -1) {
        open.push(course.id);
      }
      if (!active && found > -1) {
        open.splice(found, 1);
      }
      _this.setState({
        open: open
      });
    });
    _defineProperty(_this, "toggleOpenAll", function () {
      if (_this.state.open.length > 0) {
        _this.setState({
          open: []
        });
      } else {
        _this.setState({
          open: _toConsumableArray(_this.props.courses).map(function (course) {
            return course.id;
          })
        });
      }
    });
    _defineProperty(_this, "renderCourseRow", function (course) {
      var verdict = _this.props.lastVerdicts.find(function (verdict) {
        return verdict.courses.find(function (co) {
          return co.courseId == course.id;
        });
      });
      var open = false;
      var feedback = '';
      var creator = null;
      if (_this.state.open.indexOf(course.id) > -1) {
        open = true;
      }
      if (verdict == null) return null;
      if (moment(_this.props.start).startOf('day') > moment(verdict.published).startOf('day') || moment(_this.props.end).startOf('day') < moment(verdict.published).startOf('day')) return null;
      if (verdict.feedback != null) {
        feedback = verdict.feedback.replace(/(\r\n|\r|\n)/g, '<br />');
      }
      creator = {
        firstName: verdict.creatorFirstName,
        lastName: verdict.creatorLastName,
        id: verdict.creator
      };
      var collapsibleTrigger = /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement(ColorLabelContainer, {
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(ColorLabel, {
        content: course.title + " " + (course.year != null ? course.year : ''),
        color: course.colorCode
      })), verdict != null ? /*#__PURE__*/React.createElement(VerdictWidget, {
        verdict: verdict
      }) : course.loading ? /*#__PURE__*/React.createElement(Skeleton, null) : null, verdict != null ? /*#__PURE__*/React.createElement("span", {
        style: {
          marginLeft: '.45rem'
        }
      }, new DateTime(verdict.published).getLongDate()) : null);
      return /*#__PURE__*/React.createElement(RowItem, {
        key: course.id
      }, /*#__PURE__*/React.createElement(RowCell, null, /*#__PURE__*/React.createElement(Collapsible, {
        open: open,
        onChange: function onChange(open) {
          return _this.toggleOpen(course, open);
        },
        trigger: collapsibleTrigger
      }, verdict != null ? /*#__PURE__*/React.createElement("div", {
        className: "verdict-feedback-row".concat(!open ? ' no-print' : '')
      }, creator != null ? /*#__PURE__*/React.createElement(Person, {
        style: {
          display: 'inline-flex'
        },
        person: creator
      }, /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: DOMPurify.sanitize(feedback)
        }
      })) : /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: DOMPurify.sanitize(feedback)
        }
      }), /*#__PURE__*/React.createElement(VerdictWidget, {
        verdict: verdict
      })) : null)), /*#__PURE__*/React.createElement(RowCell, {
        shrink: true,
        onClick: function onClick() {
          return _this.onCourseClick(course);
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: function onClick() {
          return _this.onCourseClick(course);
        }
      }, _this.props.translate('Show evaluations'))));
    });
    _defineProperty(_this, "renderPublishedInformation", function (verdict) {
      return /*#__PURE__*/React.createElement("div", {
        className: "info-draft"
      }, /*#__PURE__*/React.createElement("span", {
        className: "draft-badge",
        style: {}
      }, _this.props.translate('Published') + ": " + new DateTime(verdict.published).getTimeStamp()));
    });
    _defineProperty(_this, "renderCurrentVerdict", function (verdict) {
      if (verdict == null) {
        return null;
      }
      var start = Moment('2018-01-01');
      var end = Moment(verdict.created);
      var verdictBefore = _this.props.verdicts[1];
      if (verdictBefore != null) {
        start = Moment(verdictBefore.created);
      }
      if (_this.state.verdictLoading) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            marginBottom: '2rem'
          },
          className: "verdict verdict-entry form-row"
        }, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }
      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '2rem'
        },
        className: "verdict verdict-entry form-row"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '1rem'
        }
      }, /*#__PURE__*/React.createElement("h3", null, _this.props.translate('Current verdict'))), /*#__PURE__*/React.createElement("div", {
        className: "assessment-header"
      }, _this.renderPublishedInformation(verdict)), /*#__PURE__*/React.createElement(VerdictAssessmentsDisplay, {
        userId: verdict.userId,
        course: _this.state.course,
        start: start,
        end: end
      }), /*#__PURE__*/React.createElement(VerdictDisplay, {
        verdict: verdict
      }));
    });
    _defineProperty(_this, "renderVerdict", function (verdict, index) {
      if (verdict == null) {
        return null;
      }
      var start = Moment('2018-01-01');
      var end = Moment(verdict.created);
      var verdictBefore = _this.props.verdicts[index + 1];
      if (verdictBefore != null) {
        start = Moment(verdictBefore.created);
      }
      var trigger = /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flexGrow: 1
        }
      }, Moment.utc(verdict.published).local().format("YYYY-MM-DD")), /*#__PURE__*/React.createElement("div", {
        style: {
          flexGrow: 0
        }
      }, /*#__PURE__*/React.createElement(VerdictWidget, {
        verdict: verdict
      })));
      return /*#__PURE__*/React.createElement("div", {
        className: "verdict verdict-entry form-row",
        key: 'user-verdict' + verdict.id
      }, /*#__PURE__*/React.createElement(Collapsible, {
        trigger: trigger
      }, /*#__PURE__*/React.createElement(VerdictAssessmentsDisplay, {
        userId: verdict.userId,
        course: _this.state.course,
        start: start,
        end: end
      }), /*#__PURE__*/React.createElement(VerdictDisplay, {
        verdict: verdict
      })));
    });
    _defineProperty(_this, "renderVerdictsModal", function () {
      var currentVerdict = null;
      var verdicts = null;
      if (_this.props.verdicts != null && _this.props.verdicts.length > 0) {
        currentVerdict = _this.props.verdicts[0];
        verdicts = _toConsumableArray(_this.props.verdicts);
        verdicts.splice(0, 1);
      }
      return /*#__PURE__*/React.createElement("div", null, currentVerdict != null ? _this.renderCurrentVerdict(currentVerdict) : null, /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          marginBottom: '1rem'
        }
      }, /*#__PURE__*/React.createElement("h3", null, _this.props.translate('Previous evaluations'))), _this.state.verdictLoading ? null : verdicts != null && verdicts.length != 0 ? verdicts.map(_this.renderVerdict) : /*#__PURE__*/React.createElement("div", {
        style: {
          textAlign: 'center',
          marginBottom: '2rem'
        }
      }, translate('No previous evaluations')));
    });
    _this.state = {
      loadingStudyPlan: true,
      verdictModal: false,
      verdictLoading: false,
      course: null,
      open: []
    };
    return _this;
  }
  _inherits(StudyPlans, _Component);
  return _createClass(StudyPlans, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var activeStudent;
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              activeStudent = this.props.activeStudent;
              _context2.next = 1;
              return this.loadData(activeStudent.id);
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var translate = this.props.translate;
      var open = this.state.open.length > 0;
      return /*#__PURE__*/React.createElement("div", {
        className: "section study-plan",
        style: {
          margin: 0,
          padding: 0,
          border: 0
        }
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.verdictModal,
        onClose: this.toggleVerdictModal,
        title: translate('Evaluations')
      }, this.renderVerdictsModal()), /*#__PURE__*/React.createElement(SectionTitle, null, /*#__PURE__*/React.createElement("span", null, translate('Evaluations'))), this.state.loadingStudyPlan && this.props.courses.length > 0 ? /*#__PURE__*/React.createElement(Spinner, {
        medium: true,
        center: true
      }) : /*#__PURE__*/React.createElement(DataList, {
        data: this.props.courses,
        renderRow: this.renderCourseRow,
        actions: function actions() {
          return /*#__PURE__*/React.createElement("div", {
            className: "df aic jcb"
          }, /*#__PURE__*/React.createElement("div", {
            onClick: _this2.toggleOpenAll,
            className: open ? "color--meta toggle-all flip" : "color--meta toggle-all"
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "ArrowLeft"
          }), open ? _this2.props.translate('Close all') : _this2.props.translate('Show all')));
        }
      }), this.props.courses != null && this.props.courses.length == 0 && !this.state.loadingStudyPlan ? /*#__PURE__*/React.createElement("div", null, this.props.translate('No study programs found')) : null);
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    courses: state.studyplans.courses,
    activeStudent: state.User.activeStudent,
    lastVerdicts: state.studyplans.lastVerdicts,
    verdicts: state.studyplans.verdicts,
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps, {
  getGuardianStudentVerdicts: getGuardianStudentVerdicts,
  getGuardianStudentLatestVerdicts: getGuardianStudentLatestVerdicts,
  getPlanAssessments: getPlanAssessments,
  getAssignmentAssessments: getAssignmentAssessments,
  getVerdictScales: getVerdictScales
})(StudyPlans);